<app-basic-form [form]="form" [keys]="formKeys"></app-basic-form>
<ng-container *ngIf="showAssets">
    <app-assets-table [assets]="assets" [form]="form" [tableKeys]="tableKeys" [isReadOnly]="isReadOnly" [shouldWatchAmount]="shouldWatchAmount"></app-assets-table>
</ng-container>